import React from 'react';

/**
 * Legal and marketing copy carries emphasis inside the sentence, and where the
 * emphasis falls moves with the language. So each paragraph stays a single
 * translation key and marks its own emphasis with **bold** and *italic*, which
 * this renders as <strong> and <em>.
 */
export const emphasize = (text: string): React.ReactNode => {
  const parts = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
      return <em key={i}>{part.slice(1, -1)}</em>;
    }
    return part;
  });
};

/**
 * Renders a "Label: description" string with its label bolded, without ever
 * dropping either half: the whole translated string is shown, split only on the
 * first colon, and a string with no colon simply renders as-is.
 */
export const labelled = (text: string): React.ReactNode => {
  const colon = text.indexOf(':');
  if (colon === -1) {
    return text;
  }
  return (
    <>
      <strong>{text.slice(0, colon + 1)}</strong>
      {text.slice(colon + 1)}
    </>
  );
};

export default emphasize;
